import { CSSProperties, ReactNode } from 'react'

import { PortfolioExpandableRow } from './PortfolioExpandableRow'
import { getExpandableBorderClass } from './PortfolioRowPrimitives'

interface PortfolioMainRowRenderProps {
  isExpanded: boolean
  hasExpandableContent: boolean
  toggleExpanded: () => void
}

interface PortfolioMainRowLayoutProps {
  hasExpandableContent: boolean
  mobileExpandable?: boolean
  desktopExpandable?: boolean
  renderMobile: (props: PortfolioMainRowRenderProps) => ReactNode
  renderDesktop: (props: PortfolioMainRowRenderProps) => ReactNode
  renderExpanded?: (props: PortfolioMainRowRenderProps) => ReactNode
  containerClassName?: string
  mobileClassName?: string
  desktopClassName?: string
  desktopStyle?: CSSProperties
  disableHover?: boolean
}

export function PortfolioMainRowLayout({
  hasExpandableContent,
  mobileExpandable = true,
  desktopExpandable = true,
  renderMobile,
  renderDesktop,
  renderExpanded,
  containerClassName,
  mobileClassName = 'p-3',
  desktopClassName = 'grid-cols-6 items-center py-3 px-6 gap-4',
  desktopStyle,
  disableHover = false,
}: PortfolioMainRowLayoutProps) {
  const canExpandOnMobile = hasExpandableContent && mobileExpandable
  const canExpandOnDesktop = hasExpandableContent && desktopExpandable
  const mobileInteractiveClass = canExpandOnMobile ? 'cursor-pointer' : ''
  const desktopInteractiveClass = canExpandOnDesktop ? 'cursor-pointer' : ''
  const hoverClass = disableHover ? '' : 'hover:bg-kodiak-hover-card transition-colors duration-200'

  return (
    <PortfolioExpandableRow
      hasExpandableContent={hasExpandableContent}
      containerClassName={containerClassName}
      renderMain={({ isExpanded, toggleExpanded }) => (
        <div className={getExpandableBorderClass(isExpanded)}>
          <div
            className={`sm:hidden ${mobileClassName} ${hoverClass} ${mobileInteractiveClass}`}
            onClick={canExpandOnMobile ? toggleExpanded : undefined}
          >
            {renderMobile({ isExpanded, hasExpandableContent: canExpandOnMobile, toggleExpanded })}
          </div>

          <div
            className={`hidden sm:grid ${desktopClassName} ${hoverClass} ${desktopInteractiveClass}`}
            style={desktopStyle}
            onClick={canExpandOnDesktop ? toggleExpanded : undefined}
          >
            {renderDesktop({ isExpanded, hasExpandableContent: canExpandOnDesktop, toggleExpanded })}
          </div>
        </div>
      )}
      renderExpanded={renderExpanded}
    />
  )
}
